/* Printed Love 3.0 · "Better together": the cards follow the design they have picked, and their links carry it,
   so the next product opens in the same design (the photo follows through PL.memory). */
(function () {
  'use strict';
  var root = document.querySelector('[data-pl-site="set"]'); if (!root) return;
  var data = {}; try { data = JSON.parse(root.querySelector('[data-pl-bt-json]').textContent); } catch (e) {}
  var design = (window.PL && PL.memory.startDesign()) || 'Garden';
  function draw() {
    root.querySelectorAll('[data-pl-bt-thumb]').forEach(function (img) {
      var m = data.thumbs && data.thumbs[img.getAttribute('data-pl-bt-thumb')], src = m && m[design];
      if (src && img.getAttribute('src') !== src) img.src = src;
    });
    root.querySelectorAll('[data-pl-bt-go]').forEach(function (a) { a.href = '/products/' + a.getAttribute('data-pl-bt-go') + '?design=' + encodeURIComponent(design); });
    root.querySelectorAll('[data-pl-bt-front]').forEach(function (img) { var src = data.front && data.front[design]; if (src && img.getAttribute('src') !== src) img.src = src; });
  }
  document.addEventListener('pl:change', function (e) { if (e.detail && e.detail.design) { design = e.detail.design; draw(); } });
  draw();
})();
